import { PdfExport } from './ExportPDF'
import type { ExportSettings } from './ExportTypes'

export class ExportManager {
    pdf_export: PdfExport

    constructor() {
        this.pdf_export = new PdfExport()
        document.addEventListener('DOMContentLoaded', () => this.init())
    }

    element_get_tag_name(): string {
        return 'export'
    }

    element_process(element: Element): void {
        const type = element.getAttribute('type') ?? ''
        const element_id = element.getAttribute('element_id') ?? ''

        const export_settings: ExportSettings = {
            type: type,
            element_id: element_id,
        }
        // console.log('Adding download button to element')
        this.add_download_button(element, export_settings)
    }

    init(): void {
        const elements = document.querySelectorAll(this.element_get_tag_name())
        // console.log('Found ' + elements.length + ' elements to process')
        // console.log(elements)
        const elementsArray = Array.from(elements)
        for (const element of elementsArray) {
            this.element_process(element)
        }
    }

    add_download_button(element: Element, export_settings: ExportSettings): void {
      const container = document.createElement('div')
      container.classList.add('pdf-export-button')
      const button = document.createElement('button')
      button.classList.add('icon')
      const icon = document.createElement('i')
      icon.classList.add('i')
      icon.classList.add('i_file_type_pdf')

        // button.innerText = 'Download PDF'
      button.appendChild(icon)
      button.addEventListener('click', () => this.pdf_export.exportElement(export_settings))
      container.appendChild(button)
      element.appendChild(container)
    }
}
